module.exports = __webpack_public_path__ + "static/media/s_15.67f25df1.mp3";